import { useContext } from "react";

import { FontSizeContext, type FontSizeContextValue } from "./context";

export const useFontSize = (): FontSizeContextValue => {
  const context = useContext(FontSizeContext);
  if (!context) {
    throw new Error("useFontSize must be used within FontSizeProvider");
  }
  return context;
};
